module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--fr@2-512163f36e1786bdde95039d5e5ebd6e.jpg";